// // FOR HANDLING SINGLE AND MULTIPLE SELECT DROPDOWN

// import React from 'react';
// import Select, { components } from 'react-select';
// import './CustomSelectDropdownStyle.css';

// const CustomSelectDropdown = ({
//     options,
//     value,
//     onChange,
//     name,
//     error,
//     helperText,
//     placeholder,
//     StartIcon,
//     isDisabled,
//     isMulti = false,
//     width = '100%',
//     isClearable = false
// }) => {
//     const customStyles = {
//         control: (provided, state) => ({
//             ...provided,
//             fontFamily: 'Inter',
//             borderColor: error ? 'red' : state.isFocused ? '#E5E7EB' : '#C0C0C0',
//             boxShadow: state.isFocused ? '#E5E7EB' : '#E5E7EB', // Focus box-shadow color
//             '&:hover': {
//                 borderColor: error ? 'red' : state.isFocused ? '#E5E7EB' : '#E5E7EB',
//                 boxShadow: state.isFocused ? '0 0 0 1px #E5E7EB' : 'none',
//             },
//             paddingLeft: '6px',
//         }),

//         option: (provided, state) => ({
//             ...provided,
//             fontFamily: 'Inter',
//             backgroundColor: state.isSelected ? '#D1E7FF' : state.isFocused ? '#E0E0E0' : 'transparent',
//             color: state.isSelected ? '#000' : '#333',
//             padding: '10px',
//             '&:hover': {
//                 backgroundColor: 'rgb(86 124 9)', // Hover background color
//                 color: 'white',
//             },
//         }),
//         singleValue: (provided) => ({ //for dark the letters when disable is true
//             ...provided,
//             color: isDisabled ? '#000' : '#333',
//         }),
//     };

//     const Control = ({ children, ...props }) => (
//         <components.Control {...props}>
//             {/* {StartIcon && <span className="start-icon">{StartIcon}</span>} */}
//             {children}
//         </components.Control>
//     );

//     const customMultiValueRemove = isDisabled ? () => null : components.MultiValueRemove;

//     return (
//         <div className={` ${width ? 'force-full-width-mobile' : ''}`} style={{ width: width || '100%' }}>
//             <Select
//                 isMulti={isMulti}
//                 name={name}
//                 options={options}
//                 value={value}
//                 onChange={onChange}
//                 className="custom-select"
//                 classNamePrefix="custom-select-prefix"
//                 placeholder={placeholder}
//                 styles={customStyles}
//                 components={{
//                     MultiValueRemove: customMultiValueRemove, // Conditionally hides the cross icon
//                     Control,
//                 }}
//                 isDisabled={isDisabled}
//                 // isClearable={!isMulti} // Disable clearable if it's a multi-select
//                 isClearable={isClearable ? !isClearable : !isMulti} // Disable clearable if it's a multi-select is false and isclearable is val;ue passed from true

//             />
//             {/* Error handling */}
//             {error && <span className="error-text">{helperText}</span>}
//         </div>
//     );
// };

// export default CustomSelectDropdown;


// NEW CODE 
import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import './CustomSelectDropdownStyle.css';

const CustomSelectDropdown = ({
    options = [],
    value = [],
    onChange,
    name,
    error,
    helperText,
    placeholder,
    StartIcon,
    isDisabled = false,
    isMulti = false,
    width = '100%',
    // isClearable = false,
    isClearable = true,
    fixedOptions = [] // Support fixed options
}) => {
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            fontFamily: 'Inter',
            borderColor: error ? 'red' : state.isFocused ? '#E5E7EB' : '#C0C0C0',
            boxShadow: state.isFocused ? '#E5E7EB' : '#E5E7EB', // Focus box-shadow color
            '&:hover': {
                borderColor: error ? 'red' : state.isFocused ? '#E5E7EB' : '#E5E7EB',
                boxShadow: state.isFocused ? '0 0 0 1px #E5E7EB' : 'none',
            },
            paddingLeft: '6px',
        }),

        option: (provided, state) => ({
            ...provided,
            fontFamily: 'Inter',
            backgroundColor: state.isSelected ? '#D1E7FF' : state.isFocused ? '#E0E0E0' : 'transparent',
            color: state.isSelected ? '#000' : '#333',
            padding: '10px',
            '&:hover': {
                backgroundColor: 'rgb(86 124 9)', // Hover background color
                color: 'white',
            },
        }),
        singleValue: (provided) => ({ //for dark the letters when disable is true
            ...provided,
            color: isDisabled ? '#000' : '#333',
        }),
    };

    const Control = ({ children, ...props }) => (
        <components.Control {...props}>
            {/* {StartIcon && <span className="start-icon">{StartIcon}</span>} */}
            {children}
        </components.Control>
    );

    //  Remove fixed options from being cleared
    const MultiValueRemove = (props) => {
        if (isDisabled) return null;
        const isFixed = fixedOptions.includes(props.data.value);
        return isFixed ? null : <components.MultiValueRemove {...props} />;
    };

    // Handle fixed values while changing
    const handleChange = (selected) => {
        let newValue = selected || [];

        if (isMulti) {
            // Ensure fixed options are preserved
            const fixedValues = options.filter(opt => fixedOptions.includes(opt.value));
            const nonFixed = newValue.filter(opt => !fixedOptions.includes(opt.value));
            onChange([...fixedValues, ...nonFixed]);
        } else {
            onChange(newValue);
        }
    };

    return (
        <div className={`${width ? 'force-full-width-mobile' : ''}`} style={{ width }}>
            <Select
                isMulti={isMulti}
                name={name}
                options={options}
                value={value}
                onChange={handleChange}
                className="custom-select"
                classNamePrefix="custom-select-prefix"
                placeholder={placeholder}
                // styles={customStyles}
                isDisabled={isDisabled}
                isClearable={isClearable && !isMulti}

                // isDisabled={isDisabled || options.length === 0} // Disable if no options

                menuPortalTarget={document.body}
                styles={{
                    ...customStyles,
                    menuPortal: base => ({ ...base, zIndex: 9999 }), //FOR CLOSE THE DOPDWON WHEN OTU SIDE CLICK WHEN API CALLING
                }}

                components={{
                    MultiValueRemove: MultiValueRemove,
                    Control,
                }}
            />
            {error && <span className="error-text">{helperText}</span>}
        </div>
    );
};

export default CustomSelectDropdown;
